"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var _ = __importStar(require("lodash"));
var Button_1 = __importDefault(require("components/core/buttons/Button"));
var profile_svg_1 = __importDefault(require("res/img/profile.svg"));
var logout_svg_1 = __importDefault(require("res/img/logout.svg"));
var AccountBar = function (_a) {
    var user = _a.user, logout = _a.logout;
    return (react_1.default.createElement("div", { className: "account-bar" },
        react_1.default.createElement("div", { className: "content flex flex-row" },
            react_1.default.createElement("div", { className: "account-bar__user flex flex-row" },
                react_1.default.createElement("div", { className: "account-bar__user__icon flex flex-column flex-center" },
                    react_1.default.createElement("img", { src: profile_svg_1.default, alt: "profile" })),
                react_1.default.createElement("span", null,
                    "Hi ",
                    _.startCase(user.username.replace(".", " ")))),
            react_1.default.createElement(Button_1.default, { type: "button", title: "Logout", onClick: logout, icon: react_1.default.createElement("img", { src: logout_svg_1.default, alt: "Logout" }) }, "Logout"))));
};
exports.default = AccountBar;
